module.exports = __webpack_public_path__ + "img/qr_code.0401633b.png";